module.exports = "/_next/static/images/EngageCustomers@2x-7a0f8ead2b390420e5b9fd779807426b.png";